import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightingFluorescent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.589 28.489v-8.997h24.823v8.997zM22.946 9.48V4.46h2.27v5.02zm14.1 5.215-1.58-1.58 3.13-3.15 1.6 1.6zm-14.1 28.766v-5.02h2.27v5.02zm15.65-5.558-3.13-3.15 1.58-1.6 3.15 3.15zM10.954 14.696l-3.15-3.13 1.6-1.6 3.15 3.15zm-1.55 23.208-1.6-1.6 3.15-3.15 1.6 1.6zm4.454-11.685h20.284v-4.457H13.858z" })
});
export default SvgLightingFluorescent;
